// MAF 26-05 — Processing Breakdown regions.
// Legacy form input ids are reused verbatim as store keys so the values map 1:1
// onto the Salesforce `Application_Form__c` fields (see
// docs/changes/maf-26-05/design.md → "Salesforce mapping"). Order and labels are
// taken verbatim from the client brief; do not reorder or rename without a
// matching SF-mapping update.
export const REGIONS = [
  { key: 'source_percent_eu', label: 'Europe' },
  { key: 'source_percent_latam', label: 'LATAM' },
  { key: 'source_percent_china', label: 'China' },
  { key: 'source_percent_usa', label: 'USA' },
  { key: 'source_percent_seasia', label: 'Southeast Asia' },
  { key: 'source_percent_meast', label: 'MENA' },
  { key: 'source_percent_africa', label: 'Africa' },
  { key: 'source_percent_cis', label: 'CIS' },
  { key: 'source_percent_east_asia', label: 'East Asia' },
  { key: 'source_percent_oceania', label: 'Oceania' },
  { key: 'source_percent_south_asia', label: 'South Asia' },
  { key: 'source_percent_other', label: 'Other' },
  { key: 'source_percent_global', label: 'Global' },
] as const

export const REGION_KEYS = REGIONS.map((r) => r.key)

export const MONTHLY_VOLUME_KEY = 'estimated_monthly_volume'
